import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';
import './Icon_type_eye.css';

export interface WithTypeEyeProps {
  type?: 'eye';
}

export const withTypeEye = withBemMod<WithTypeEyeProps>(
    'Icon',
    { type: 'eye' },
    (Icon): FC => ((props): ReactElement => (<Icon {...props} />)),
);

export default withTypeEye;
